import { render, staticRenderFns } from "./searchResultItems.vue?vue&type=template&id=780adf64&scoped=true"
import script from "./searchResultItems.vue?vue&type=script&lang=js"
export * from "./searchResultItems.vue?vue&type=script&lang=js"
import style0 from "./searchResultItems.vue?vue&type=style&index=0&id=780adf64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780adf64",
  null
  
)

export default component.exports